import React from 'react';
import SelectPopup from './SelectPopup';
import { resetModule as reset } from '../../../service/command';
import { filterDetectModules } from '../../../js/utils';

const modules = [
  'cpu1',
  'cpu2',
  'rtc',
  'radar',
  'geo'
];

export default function Reboot() {
  const filterModules = filterDetectModules(modules);

  return (
    <SelectPopup
      title="重置"
      modules={filterModules}
      defaultSelectValue={filterModules[0]}
      onConfirm={(module) => {
        return reset(module);
      }}
    />
  );
}
